// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3KZwN","row":"ProcedureTreatmentSummary_row__VHpvp"};